import { combineReducers } from 'redux';

import screenReducer from './reducers/screenReducer';
import gameDetailsReducer from './reducers/gameDetailsReducer';
import roundReducer from './reducers/roundReducer';
import questionReducer from './reducers/questionReducer';
import confirmationButtonReducer from './reducers/confirmationButtonReducer';
import alexReducer from './reducers/alexReducer';
import speakerReducer from './reducers/speakerReducer';
import borderReducer from './reducers/borderReducer';
import sliderReducer from './reducers/sliderReducer';

export const reducerCollection = {
  screen: screenReducer,
  gameDetails: gameDetailsReducer,
  round: roundReducer,
  question: questionReducer,
  confirmationButton: confirmationButtonReducer,
  alexState: alexReducer,
  speakerState: speakerReducer,
  border: borderReducer,
  sliders: sliderReducer,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
